import isArray from "lodash/isArray";

const removeEmptyFields = (fields = {}) =>
  Object.keys(fields)
    .filter((key) => fields[key] != null && fields[key] !== "")
    .reduce(
      (acc, val) =>
        typeof fields[val] === "object" && !isArray(fields[val]) && !(fields[val] instanceof File)
          ? { ...acc, [val]: removeEmptyFields(fields[val]) }
          : { ...acc, [val]: fields[val] },
      {}
    );

export default removeEmptyFields;
